import axios from "axios";
import store from "@/store";
import Router from "@/router";
export default function () {
	axios.interceptors.request.use(function (config) {
		if ( store.state.auth.user  ) {
			config.headers.Authorization = 'Bearer '+store.state.auth.user.token;
			config.headers.posId = store.state.auth.posId;
		}
		config.baseURL = store.state.API_BASE;
		// config.baseURL = process.env.VUE_APP_BASE_URL;
		return config
	}, function (err) {
		return Promise.reject(err)
	})

	axios.interceptors.response.use(function (response) {
		return response;
	}, function (err) {
		if (err.response) {
			if (err.response.status === 422) {
				if (err.response.data.errors?.pos_id && err.response.data.errors?.pos_id.some((el) => el === 'The selected pos id is invalid.')) {
					store.dispatch('terminalReset').then(() => {
						store.dispatch('alert/warning', 'All data has been updated, please setup terminal again')
						// Router.replace({path: '/auth/login'})
						// setTimeout(() => {
						// 	window.location.reload()
						// }, 0)
					});
				}
			} else if (err.response.status === 401) {
				if (store.state.auth.user) {
					store.dispatch('logoutUser').then(() => {
						store.dispatch('alert/warning', 'Your account or terminal has been updated, please login again')
						Router.replace({path: '/auth/login'})
						// setTimeout(() => {
						// 	window.location.reload()
						// }, 0)
					});
				};
			} else if (err.response.status === 403) {
				store.dispatch('alert/error', err.response.data.message ? err.response.data.message : err.response.data);
				if (err.response.data === 'User without POS' || err.response.data === 'User without POS and Department') {
					store.dispatch('logoutUser').then(() => {
						store.dispatch('alert/warning', 'Your account or terminal has been updated, please login again')
						Router.replace({path: '/auth/login'});
						store.dispatch('terminalReset');
					})
				} else if (err.response.data === 'User does not have access privileges') {
					store.dispatch('logoutUser').then(() => {
						Router.replace({path: '/auth/login'});
						store.dispatch('alert/warning', 'Your account has been updated, please login again')
					})
				} else if (err.response.data === 'POS is not active') {
					store.dispatch('terminalReset').then(() => {
						store.dispatch('alert/warning', 'Your terminal has been deactivated, please relogin and setup again')
						Router.replace({path: '/auth/login'})
					})
				}
			} else {
				if (err.response) {
					if (err.response.data.errors) {
						for (var key in err.response.data.errors) {
							if (err.response.data.errors.hasOwnProperty(key)) {
								store.dispatch('alert/error', err.response.data.errors[key].join(','))
							}
						}
					} else if (err.response.data.message) {
						const needIgnoreMessage = Boolean(['Discount cannot be more than 50% of amount'].includes(err.response.data.message));
						if (!needIgnoreMessage) {
							store.dispatch('alert/error', err.response.data.message)
						}
					}
				}
			}
		} else {
			store.dispatch('alert/error', 'An unusual error has occurred. Please verify your network connection');
		}
		return Promise.reject(err)
	})
}
